import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const AkaboushaShoyuKbn = props => {
  return <Dropdown.Static kubunKey='akabousha_shoyu_kbn' {...props} />
}
